<template>
    <div v-if="open" class="notify-popup-overlay">
      <div class="notify-popup-content" dir="rtl">
        <img src="/assets/img/bonauf.png" alt="Bonauf Logo" class="notify-popup-logo" />
        <button class="close-btn" @click="$emit('close')">×</button>
        <div class="notify-popup" v-html="contents"></div>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: "SecurityNoticePopup",
    props: {
      open: {
        type: Boolean,
        default: false
      },
      content: {
        type: String,
        default: ""
      }
    },
    computed: {
      contents() {
        return this.content;
      }
    }
  };
  </script>

  <style scoped>
  .notify-popup-overlay {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }
  .notify-popup-content {
    background: #fff;
    padding: 2rem 1.2rem;
    border-radius: 8px;
    max-width: 450px; /* wider for desktop */
    width: 90vw;      /* responsive width */
    text-align: center !important;
    position: relative;
    font-size: 1.35rem;
    margin: 0; /* Remove auto margin for more compactness */
    max-height: 90vh;
    overflow-y: auto;
  }
  .close-btn {
    position: absolute;
    top: 12px;
    left: 12px;
    background: transparent;
    border: none;
    font-size: 3.5rem;
    font-weight: 400;
    cursor: pointer;
    color: #333;
    padding: 0;
    line-height: 1;
  }
  button:not(.close-btn) {
    margin-top: 1rem;
    padding: 0.5rem 1.5rem;
  }
  .notify-popup-logo {
    max-width: 200px;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .notify-popup ::v-deep p {
    margin-bottom: 0px !important;
  }

  @media (max-width: 900px) {
    .notify-popup-content {
      max-width: 98vw;
      padding: 0.7rem;
      font-size: 1.1rem;
    }
  }

  @media (max-width: 600px) {
    .notify-popup-content {
      padding: 1.25rem 0.5rem;
      max-width: 90vw;
      width: 90vw;
      font-size: 1.25rem;
    }
    .notify-popup-logo {
      max-width: 160px; /* larger logo on mobile too */
      margin-top: 2.2rem;
      margin-bottom: 0.7rem; /* more space below logo on mobile */
    }
  }
  </style>
